// extracted by mini-css-extract-plugin
export default {"col_box":"index_col_box_wgDZP","col_navlist":"index_col_navlist_IlwMt","pa":"index_pa_XjrE-"};